import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '../api/rootSaga';
import organizationSlice from '../api/organizations/organizationSlice';
import partnerSlice from '../api/partners/partnerSlice';
import authSlice from '../api/auth/authSlice';
import planSlice from '../api/plans/planSlice';
import subscriptionSlice from '../api/subscriptions/subscriptionSlice';
import invoiceSlice from '../api/invoices/invoiceSlice';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    auth: authSlice,
    organizations: organizationSlice,
    partners: partnerSlice,
    plans: planSlice,
    subscriptions: subscriptionSlice,
    invoices: invoiceSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;
